import AdminOrganizationDetail from './AdminOrganizationDetail'
export default AdminOrganizationDetail
